import { createBigDecimal } from '@0xtorch/big-decimal'
import type { Transfer } from '@0xtorch/core'
import { createSolanaAddressId } from '@pkg/solana'
import type { TokenTransfer } from '@pkg/solana'
import { nativeTokenDecimals } from '../constants'
import { createDirection } from './createDirection'

export const createTokenTransfer = ({
  tokenTransfer,
  relatedAddresses,
}: {
  tokenTransfer: TokenTransfer
  relatedAddresses: Set<string>
}): Transfer | undefined => {
  const direction = createDirection(
    tokenTransfer.from
      ? createSolanaAddressId({ address: tokenTransfer.from })
      : undefined,
    tokenTransfer.to
      ? createSolanaAddressId({ address: tokenTransfer.to })
      : undefined,
    relatedAddresses,
  )

  if (!direction) {
    return undefined // Internal transfer
  }

  if (tokenTransfer.type === 'native') {
    return {
      direction,
      asset: {
        symbol: 'SOL',
        type: 'CryptoCurrency',
        id: 'solana',
        name: 'Solana',
        updatedAt: 0,
      },
      amount: createBigDecimal(tokenTransfer.amount, nativeTokenDecimals),
    }
  }

  if (tokenTransfer.type === 'spl' && 'token' in tokenTransfer) {
    return {
      direction,
      asset: tokenTransfer.token.currency,
      amount: createBigDecimal(
        tokenTransfer.amount,
        tokenTransfer.token.decimals,
      ),
    }
  }

  return undefined
}
